import React from "react";
import { useReportFileHooks } from "./hooks";

export const ReportFilePage = React.memo(() => {
  useReportFileHooks();

  return <></>;
});
